import { configureStore } from '@reduxjs/toolkit';
import generationSlice from './generationSlice';
import boardMenuReducer from './boardMenuSlice';
import generalReducer from './generalSlice';
import canvasReducer from './canvasSlice';
import trialReducer from './trialSlice';

export default configureStore({
  reducer: {
    generation: generationSlice,
    boardMenu: boardMenuReducer,
    general: generalReducer,
    canvas: canvasReducer,
    trial: trialReducer,
  },
});
